<!-- <app-sidebar></app-sidebar> -->
<app-hire-sidebar></app-hire-sidebar>
<!-- <app-navbar></app-navbar> -->

<div class="row fixedAtTopbeforeStyle">
  <div class="col-md-3 h-100v pr-1">
    <div class="screen-ai-filter-ui" *ngIf="jobDetails?.candidatesCount">
      <app-person-search-filter></app-person-search-filter>
    </div>
    <div class="p-3 col mr-1 sidebar-card" *ngIf="!jobDetails?.candidatesCount">
      <app-sidebar-screen></app-sidebar-screen>
    </div>
  </div>

  <div class="col-md-9 candidate-card pl-0">
    <div class="mb-1" style="background-color: #ecf0f4;position: sticky; top: 70px; z-index: 1;">
      <div class="wccard p-2 mb-0" style="box-shadow: 0 1px 4px 0 rgba(207, 199, 199, 0.5);">
        <div class="" [ngClass]="{'mb-2 pb-2 bbgray':showProgressBar}">
          <div class="d-flex justify-content-between w-100 mb-2">
            <div class="d-flex">
              <!-- <div class="companylogo">
                <img style="width: 30px; height: 30px;" src={{jobDetails?.logo}} alt="logo">
              </div>   -->

              <div class="text-9696 f-12">
                <div (click)="openViewJobDetails()"
                  class="f-14 font-weight-600 blue-text text-webbtree-green pointer mb-1">{{jobDetails?.data?.name | titlecase }}
                </div>
                <div class="f-14 font-weight-normal d-flex">
                  <span *ngIf="jobDetails?.data?.industry" class="mr-1"><i class="fa-regular fa-flag-pennant mr-1"></i>
                    {{jobDetails?.data?.industry ? jobDetails?.data?.industry[0] : ''  | titlecase }}</span>
                  <span *ngIf="jobDetails?.data?.industry" class="d-flex align-items-center f-5"><i
                      class="fa-solid fa-circle mr-1" style="font-size: 5px;"></i></span>

                  <span *ngIf="jobDetails?.data?.location"><i class="fa-regular fa-location-dot mr-1"></i>{{jobDetails?.data?.location | titlecase}}</span>
                </div>
              </div>
            </div>
            <div class="d-flex align-items-center">
              <div class="mr-2" *ngIf="jobDetails?.candidatesCount">
                <div class="dropdown filter-icon">
                  <a data-testid="auto-app-candidate-listing-a-1" class="btn-trms-regular dropdown-toggle filter-btn" href="#" role="button" appDropdownToggle
                    aria-expanded="false">
                    <i class="fa-light fa-arrow-down-arrow-up"></i>
                  </a>

                  <div class="dropdown-menu">
                    <div class="position-relative">
                      <input data-testid="auto-app-candidate-listing-input-1" id="radio-1" class="radio-custom" name="radio-group" type="radio" checked
                        (change)="onFilterChange($event)" value="score_desc" [(ngModel)]="radioBtnFilter">
                      <label for="radio-1" class="radio-custom-label">Screen AI Score (High to Low)</label>
                    </div>
                    <div class="position-relative">
                      <input data-testid="auto-app-candidate-listing-input-2" id="radio-2" class="radio-custom" name="radio-group" type="radio"
                        (change)="onFilterChange($event)" value="score_asc" [(ngModel)]="radioBtnFilter">
                      <label for="radio-2" class="radio-custom-label">Screen AI Score (Low to High)</label>
                    </div>
                    <div class="position-relative">
                      <input data-testid="auto-app-candidate-listing-input-3" id="radio-3" class="radio-custom" name="radio-group" type="radio"
                        (change)="onFilterChange($event)" value="createdon_desc" [(ngModel)]="radioBtnFilter">
                      <label for="radio-3" class="radio-custom-label">Application Date (New to Old)</label>
                    </div>
                    <div class="position-relative">
                      <input data-testid="auto-app-candidate-listing-input-4" id="radio-4" class="radio-custom" name="radio-group" type="radio"
                        (change)="onFilterChange($event)" value="createdon_asc" [(ngModel)]="radioBtnFilter">
                      <label for="radio-4" class="radio-custom-label">Application Date (Old to New)</label>
                    </div>
                  </div>
                </div>

              </div>
              <div *ngIf="!showProgressBar">
                <button data-testid="auto-app-candidate-listing-button-1" class="btn-trms-regular upload-candidate-btn" *ngIf="jobDetails?.data?.source == 'create' && jobDetails?.candidatesCount && !candidateListLoader && !showProgressBar"
                  (click)="uploadCandidate()"><span class="upload-icon"><i
                      class="fa-solid fa-arrow-up-from-bracket"></i></span> <span>Upload Candidates</span></button>
                <!--
                <button data-testid="auto-app-candidate-listing-button-2" class="btn-trms-regular upload-candidate-btn" *ngIf="jobDetails?.data?.source == 'import'"
                  (click)="startScreening(jobDetails?.data)"><span class="upload-icon"><i
                      class="fa-regular fa-arrows-repeat"></i></span><span>Sync Candidates</span></button> -->

                <!-- <button data-testid="auto-app-candidate-listing-button-3" class="btn-trms-regular upload-candidate-btn"
                  *ngIf="jobDetails?.data?.source == 'import' && jobDetails?.candidatesCount  && !showProgressBar"
                  [ngClass]="{ 'text-center': startScreeningLoader }" (click)="startScreening(jobDetails?.data)"
                  [disabled]="startScreeningLoader || !availableIntegrations?.length"
                  [matTooltip]="!availableIntegrations?.length ? 'Please connect your ATS' : ''"
                  [matTooltipDisabled]="!!availableIntegrations?.length" [matTooltipClass]="{ 'red-tooltip text-black': true }">
                  <span class="upload-icon" *ngIf="!startScreeningLoader"><i class="fa-regular fa-arrows-repeat"></i></span>
                  <span [ngClass]="{ 'spinner-border text-blue spinner-size': startScreeningLoader }"
                    [ngStyle]="{ 'width: 20px; height: 20px;': startScreeningLoader }">
                    {{startScreeningLoader ? '' : 'Sync Candidates'}}
                  </span>
                </button> -->

                <span [matTooltip]="screeningTooltip"
                  [matTooltipDisabled]="!!availableIntegrations?.length || !isTeamAdmin" matTooltipClass="red-tooltip text-black">
                  <button data-testid="auto-app-candidate-listing-button-4" class="btn-trms-regular upload-candidate-btn"
                    *ngIf="jobDetails?.data?.source == 'import' && jobDetails?.candidatesCount && !showProgressBar"
                    [ngClass]="{'text-center': startScreeningLoader, 'sync-btn-disabled-ui': !availableIntegrations?.length || !isTeamAdmin}"
                    (click)="startScreening(jobDetails?.data)" [disabled]="startScreeningLoader || !availableIntegrations?.length || !isTeamAdmin">
                    <span class="upload-icon" *ngIf="!startScreeningLoader"
                      [ngClass]="{ 'sync-btn-disabled-icon-ui': !availableIntegrations?.length }">
                      <i class="fa-regular fa-arrows-repeat"></i>
                    </span>


                    <span [ngClass]="{ 'spinner-border text-blue spinner-size': startScreeningLoader }"
                      [ngStyle]="{ 'width: 20px; height: 20px;' : startScreeningLoader }">
                      {{ startScreeningLoader ? '' : 'Sync Candidates' }}
                    </span>
                  </button>
                </span>

              </div>
            </div>
          </div>
          <div class="d-flex justify-content-between" *ngIf="!showProgressBar && totalCandidateCount">
            <div class="f-12 font-weight-normal text-9696">
              Total Candidate : {{totalCandidateCount}}
            </div>
            <div class="f-12 font-weight-normal text-9696">
              Last Updated on: {{jobDetails?.data?.updated_at | date:'MMM dd, yyyy | HH:mm':'UTC'}} UTC
            </div>
          </div>
        </div>

        <div *ngIf="showProgressBar && !showProgressBarLoader">
          <div class="p-2">
            <div>
              <p class="position-relative text-webbtree-green font-weight-500 text-center mb-2"> <span
                  class="starts gen-ai-text"><i class="fa-solid fa-stars"></i></span> <span
                  class="position-relative ml-1 mr-2">Screen<span class="ai-text">AI</span></span> is evaluating your
                candidates..</p>
              <p class="text-center text-9696 f-12 mb-0">This process may take a few minutes. You’ll be informed by email when it’s done.</p>
            </div>
          </div>
          <div>
            <div class="progress-container" *ngIf="showProgressBar">
              <div class="progress-bar" [style.width.%]="progress"></div>
            </div>
          </div>
        </div>

        <!-- <div class="h-50 justify-content-center d-flex flex-column py-3 mt-6" style="border: 1px solid red;" *ngIf="showProgressBarLoader">
          <div *ngFor="let i of [1]">
            <app-ai-sourcing-profile-skeleton></app-ai-sourcing-profile-skeleton>
          </div>
        </div> -->

      </div>
    </div>

    <div class="col wccard pb-3" [ngClass]="{'pb-3':(jobDetails?.data?.source == 'create' && !candidateList?.length && !jobDetails?.candidatesCount && !candidateListLoader && !showProgressBar)|| (jobDetails?.data?.source == 'import' && !showProgressBar && !candidateList?.length && ((!jobDetails?.data?.sync_status && !jobDetails?.data?.groq_status) && (jobDetails?.data?.sync_status !== 'failed' || jobDetails?.data?.groq_status !== 'failed')))|| (jobDetails?.data?.source == 'import' && !candidateList?.length && !((!jobDetails?.data?.sync_status && !jobDetails?.data?.groq_status) && (jobDetails?.data?.sync_status !== 'failed' || jobDetails?.data?.groq_status !== 'failed')))}">
        <div class="empty-resume-upload-card" *ngIf="jobDetails?.data?.source == 'create' && !candidateList?.length && !jobDetails?.candidatesCount && !candidateListLoader && !showProgressBar">
          <div class="text-center p-55">
            <img src="../../../assets/resume-screening/user-profile-empty.png" alt="">
            <p class="f-14">Drag and drop or click here to select multiple files</p>
            <p class="f-12">Accepted file types: doc, docx, pdf, </p>
            <p class="f-12">Max File size: 10 MB | Max files: 25</p>
            <button data-testid="auto-app-candidate-listing-button-5" class="btn-trms-light-with-border mt-3" (click)="uploadCandidate()">Upload Now</button>
          </div>
        </div>

        <!-- Ready to run static screen -->
        <div class="ready-to-run-screen" *ngIf="jobDetails?.data?.source == 'import' && !showProgressBar && !candidateList?.length && !jobDetails?.candidatesCount">
          <div class="text-center p-55">
            <div class="gen-ai-text">
              <i class="fa-solid fa-stars f-24 mb-2"></i>
            </div>
            <p class="f-18 font-weight-600 mb-2">Ready to Run <span class="position-relative mr-3">Screen<span
                  class="ai-text">AI</span></span> ?</p>
            <p class="f-14"><span class="position-relative mr-2">Screen<span class="ai-text">AI</span></span> will
              analyze
              each candidate and<br> generate ranked insights for this job.</p>

            <!-- <button data-testid="auto-app-candidate-listing-button-6" class="btn-trms-regular btn-run-screen position-relative" [ngClass]="{ 'text-center': startScreeningLoader }"
              (click)="startScreening(jobDetails?.data)" [disabled]="startScreeningLoader || !availableIntegrations?.length"
              [matTooltip]="!availableIntegrations?.length ? 'Please connect your ATS' : ''"
              [matTooltipDisabled]="!!availableIntegrations?.length" [matTooltipClass]="{ 'red-tooltip text-black': true }">
              <span [ngClass]="{ 'spinner-border text-white spinner-size': startScreeningLoader }"
                [ngStyle]="{ 'width: 20px; height: 20px;': startScreeningLoader }">
                {{startScreeningLoader ? '' : 'Run Screen'}} <span class="position-absolute f-10" style="top: 6px;"
                  *ngIf="!startScreeningLoader">AI</span>
              </span>
            </button> -->

            <span [matTooltip]="screeningTooltip"
              [matTooltipDisabled]="!!availableIntegrations?.length || !isTeamAdmin" matTooltipClass="red-tooltip text-black">
              <button data-testid="auto-app-candidate-listing-button-7" class="btn-trms-regular btn-run-screen position-relative"
                [ngClass]="{'text-center': startScreeningLoader, 'btn-disabled-ui': !availableIntegrations?.length, 'btn-run-screen': availableIntegrations?.length || !isTeamAdmin}"
                (click)="startScreening(jobDetails?.data)" [disabled]="startScreeningLoader || !availableIntegrations?.length || !isTeamAdmin">
                <span [ngClass]="{ 'spinner-border text-white spinner-size': startScreeningLoader }"
                  [ngStyle]="{ 'width: 20px; height: 20px;' : startScreeningLoader }">
                  {{ startScreeningLoader ? '' : 'Run Screen' }}

                  <span class="position-absolute f-10" style="top: 6px;" *ngIf="!startScreeningLoader">
                    AI
                  </span>
                </span>
              </button>
            </span>

          </div>
        </div>

        <!-- setting up static screen -->
        <!-- <div class="setting-up-screen" *ngIf="jobDetails?.data?.source == 'import' && jobDetails?.data?.sync_status == null && jobDetails?.data?.last_on_demand_sync == null">
          <div class="text-center">
            <h2 class="position-relative f-24 font-weight-600 mb-2 text-black">Setting Up <span
                class="position-relative mr-3">Screen<span class="ai-text"
                  style="font-size: 16px!important;">AI</span></span> for Your Job</h2>
            <p class="f-14 mb-0">This may take a few minutes.</p>
          </div>
          <div class="stepper-container">
            <div class="stepper-left">
              <img src="../../../assets/resume-screening/stepper-left.svg" alt="">
            </div>
            <div class="stepper-right">
              <div class="step-section">
                <div  class="step-no active">
                <div class="step-box"><i class="fa-regular fa-circle-notch fa-spin"></i></div>
                </div>
                <div class="step-content">
                  <p>Connecting to ATS</p>
                  <p> Establishing a secure link to retrieve job data.</p>
                </div>
              </div>
              <div class="step-section">
                <div class="step-no">
                <div class="step-box"><i class="fa-regular fa-circle-notch fa-spin"></i></div>
                </div>
                <div class="step-content">
                  <p>Importing Job Details</p>
                  <p> Loading the role information needed for evaluation.</p>
                </div>
              </div>
              <div class="step-section">
                <div  class="step-no">
                <div class="step-box"><i class="fa-regular fa-circle-notch fa-spin"></i></div>
                </div>
                <div class="step-content">
                  <p>Syncing Candidates</p>
                  <p>Fetching applicants from your ATS. This may take a few minutes.</p>
                </div>
              </div>
              <div class="step-section">
                <div class="step-no">
                <div class="step-box"><i class="fa-regular fa-circle-notch fa-spin"></i></div>
                </div>

                <div class="step-content">
                  <p>Preparing ScreenAI Evaluation</p>
                  <p>Setting up your evaluation environment and configuring ScreenAI analysis.</p>
                </div>
              </div>
            </div>
          </div>
        </div> -->


    </div>
     <!-- common screen -->
        <div class="uploadResumeBelowRow mt-3" *ngIf="!candidateList?.length && !jobDetails?.candidatesCount && !showProgressBar && !candidateListLoader">
          <div class="uploadResumeStepsCard">
            <i class="fa-regular fa-file-import f-12"></i>
            <div>
              <p class="font-weight-600 f-12 mb-1">1. Upload Candidate Resumes</p>
              <p class="f-12 font-weight-normal mb-0">Add PDFs or documents directly to this job.</p>
            </div>
          </div>
          <div class="uploadResumeStepsCard">
            <i class="fa-regular fa-stars f-12"></i>
            <div>
              <p class="font-weight-600 f-12 mb-1">2. ScreenAI Evaluates Each Profile</p>
              <p class="f-12 font-weight-normal mb-0">Candidates are assessed against your job requirements and
                evaluation
                criteria.</p>
            </div>
          </div>
          <div class="uploadResumeStepsCard">
            <i class="fa-regular fa-list-check f-12"></i>
            <div>
              <p class="font-weight-600 f-12 mb-1">3. Get Ranked Results with Insights</p>
              <p class="f-12 font-weight-normal mb-0">See ordered recommendations with clear fit insights for faster
                decisions.</p>
            </div>
          </div>
        </div>
    <div *ngFor="let candidate of candidateList; let i = index" class="row">
      <div class="col">
        <app-ai-sourcing-profile-card [data]="candidate" [calledfrompage]="'resume-screen'" [index]="i" [showProgressBar]="showProgressBar"
          (childEvents)="eventHandler($event)">
        </app-ai-sourcing-profile-card>
      </div>
    </div>

    <div class="new-card d-flex justify-content-center wccard align-items-center"
      [ngClass]="{'sticky-pagination': isScrolled}" *ngIf="totalCandidateCount > 1">
      <ngb-pagination [collectionSize]="totalCandidateCount" [maxSize]="5" [pageSize]="profilesPerPage" [rotate]="true"
        (pageChange)="setPage($event)" [(page)]="currentPage">
        <ng-template ngbPaginationPrevious> <span></span></ng-template>
        <ng-template ngbPaginationNext>
          <span>Next</span>
        </ng-template>
      </ngb-pagination>

      <div class="page-selection">
        Showing
        <select data-testid="auto-app-candidate-listing-select-1" class="wc-select" name="" id="" [(ngModel)]="profilesPerPage" (change)="updatePagePreference()">
          <option value="10">10</option>
          <option value="25">25</option>
          <option value="50">50</option>
        </select>
        Candidate per page
      </div>
    </div>

    <div class="h-50 justify-content-center d-flex flex-column py-3 mt-6" *ngIf="candidateListLoader || (showProgressBar && !candidateList?.length)">
      <div *ngFor="let i of [1,2,3,4,5]">
        <app-ai-sourcing-profile-skeleton></app-ai-sourcing-profile-skeleton>
      </div>
    </div>

      <div class="justify-content-center align-items-center d-flex p-3 wccard text-center" *ngIf="!candidateListLoader && !candidateList?.length && jobDetails?.candidatesCount">
        <div>
          <img src="../../../assets/empty-credit.png" alt="">
          <p>No Candidates Available </p>
        </div>
      </div>

    <div class="row justify-content-start">
      <div id="overlay" (click)="closeNav()">
      </div>
    </div>

    <div id="quickView">
      <div class="" *ngIf="showCandidate">
        <app-person-search-candidate-slider [data]="currentCandidate" [viewMoreSkills]="viewMoreSkills"
          [highlightkeywords]="highlightkeywords" [tabType]="tabType" (childEvents)="eventHandler($event)"
          (handleOutputEvent)="eventHandler($event)" [currentIndex]="currentIndex" [calledfrompage]="'resume-screen'">
        </app-person-search-candidate-slider>
      </div>
    </div>
  </div>
</div>

<ngb-alert class="ngb-alert" *ngIf="successMessage" type="success" (close)="successMessage = ''">
  <span class="successCheck"><i class="fal fa-check"></i> </span>
  <span class="successmsg">{{ successMessage }}</span>
</ngb-alert>

<ngb-alert class="ngb-alert" *ngIf="errorMessage" type="danger" (close)="errorMessage = ''">
  <span class="errorCheck"><i class="fal fa-times"></i></span>
  <span class="errormsg"> {{ errorMessage }} </span>
</ngb-alert>

<ngb-alert class="ngb-alert" style="background-color: yellow !important;" *ngIf="infoMessage" type="info"
  (close)="infoMessage = ''">
  <span class="infoCheck"><i class="fal fa-info-circle"></i></span>
  <span class="infomsg ml-1">{{ infoMessage }}</span>
</ngb-alert>
